import script from "./AddGroupsToWorkspaceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddGroupsToWorkspaceModal.vue?vue&type=script&setup=true&lang=js"

import "./AddGroupsToWorkspaceModal.vue?vue&type=style&index=0&id=83c6f6c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83c6f6c0"]])

export default __exports__